export default "__VITE_ASSET__5RFXWAaC__"